'use strict';

module.exports = /^'?(\d{1,2})$/;